import WorkdocStore from '../../../stores/WorkdocStore';
import LayoutField from './layout/form-layout';

export function LoadCategoryOptions(cat_id) {
  return new Promise((resolve, reject) => {
    WorkdocStore.loadCarCategory(cat_id, resp => {
      const options = resp.data.map(item => ({
        label: item.name,
        value: item.cat_id,
      }));

      resolve(options);

    }, (err) => reject(err));
  });

}

export const CAR_TYPE_OPTIONS = [
  {
    value: 'SEDAN',
    label: 'รถเก๋ง',
  },
  {
    value: 'PICKUP',
    label: 'รถกระบะ',
  },
  {
    value: 'PICKUPTRUCK',
    label: 'รถกระบะบรรทุก',
  },
  {
    value: 'VAN',
    label: 'รถตู้',
  },
  {
    value: 'MINIVAN',
    label: 'รถตู้แวน',
  },
  {
    value: 'TRUCK',
    label: 'รถบรรทุก',
  },
];

export const VEHICLE_TYPE_OPTIONS = [
  {
    "type": "system",
    "label": "รถบรรทุก",
    "value": "TRUCK"
  },
  {
    "label": "หางครัซซี",
    "value": "TRAILER",
    "type": "system"
  },
  {
    "label": "รถหัวลาก",
    "value": "TRACTORTRUCK",
    "type": "system"
  },
  {
    "label": "กระบะคอก",
    "value": "DUMPTRUCK",
    "type": "system"
  },
  {
    "label": "รถโฟลคลิฟท์",
    "value": "FORKLIFT",
    "type": "system"
  },
  {
    "label": "รถบรรทุกติดเคลน",
    "value": "CRANETRUCK",
    "type": "system"
  },
  {
    "label": "รถแทงค์บรรทุก",
    "value": "TANKTRUCK",
    "type": "system"
  },
  {
    "label": "รถบรรทุก แบบเปลือย",
    "value": "EMPTYTRUCK",
    "type": "system"
  },
  {
    "label": "เทรลเลอร์บรรทุกรถยนต์",
    "value": "CARCARRIER",
    "type": "system"
  },
  {
    "label": "หางแทงค์บรรทุก",
    "value": "CHEMICALTANK",
    "type": "system"
  },
  {
    "label": "รถพ่วง",
    "value": "TRUCK",
    "type": "custom"
  },
  {
    "label": "เทรลเลอร์",
    "value": "TRAILER",
    "type": "custom"
  },
  {
    "label": "ตู้แห้ง",
    "value": "TRAILER",
    "type": "custom"
  },
  {
    "label": "กึ่งพ่วง",
    "value": "TRUCK",
    "type": "custom"
  },
  {
    "label": "หาง 18 ล้อ",
    "value": "TRAILER",
    "type": "custom"
  },
  {
    value: 'SEDAN',
    label: 'รถเก๋ง',
  },
  {
    value: 'PICKUP',
    label: 'รถกระบะ',
  },
  {
    value: 'PICKUPTRUCK',
    label: 'รถกระบะบรรทุก',
  },
  {
    value: 'VAN',
    label: 'รถตู้',
  },
  {
    value: 'MINIVAN',
    label: 'รถตู้แวน',
  },
];

export const CAR_COLOR_OPTIONS = [
  {
    value: 'BLACK',
    label: 'สีดำ',
  },
  {
    value: 'BLUE',
    label: 'สีน้ำเงิน',
  },
  {
    value: 'RED',
    label: 'สีแดง',
  },
  {
    value: 'GREEN',
    label: 'สีเขียว',
  },
  {
    value: 'WHITE',
    label: 'สีขาว',
  },
];

let Last50Year = [];
const currentYear = new Date().getFullYear();
for (let i = 0; i < 50; i++) {
  const year = currentYear - i;
  Last50Year.push({
    value: year,
    label: year,
  });
}

export const MODEL_YEAR_OPTIONS = Last50Year;

export const POLICY_TYPE_OPTIONS = [
  'ประกันภัยชั้น 1',
  'ประกันภัยชั้น 2',
  'ประกันภัยชั้น 2+',
  'ประกันภัยชั้น 3',
  'ประกันภัยชั้น 3+',
  'ประกันภัยชั้น 4',
  'พรบ'
].map(
  item => ({value: item, label: item}));


export const PROVINCE_OPTIONS = [
  'นครราชสีมา', 'เชียงใหม่', 'กาญจนบุรี', 'ตาก',
  'อุบลราชธานี', 'สุราษฎร์ธานี', 'ชัยภูมิ', 'แม่ฮ่องสอน', 'เพชรบูรณ์', 'ลำปาง',
  'อุดรธานี', 'เชียงราย', 'น่าน', 'เลย', 'ขอนแก่น', 'พิษณุโลก', 'บุรีรัมย์',
  'นครศรีธรรมราช', 'สกลนคร', 'นครสวรรค์', 'ศรีสะเกษ', 'กำแพงเพชร', 'ร้อยเอ็ด',
  'สุรินทร์', 'อุตรดิตถ์', 'สงขลา', 'สระแก้ว', 'กาฬสินธุ์', 'อุทัยธานี',
  'สุโขทัย', 'แพร่', 'ประจวบคีรีขันธ์', 'จันทบุรี', 'พะเยา', 'เพชรบุรี',
  'ลพบุรี', 'ชุมพร', 'นครพนม', 'สุพรรณบุรี', 'ฉะเชิงเทรา', 'มหาสารคาม',
  'ราชบุรี', 'ตรัง', 'ปราจีนบุรี', 'กระบี่', 'พิจิตร', 'ยะลา', 'ลำพูน',
  'นราธิวาส', 'ชลบุรี', 'มุกดาหาร', 'บึงกาฬ', 'พังงา', 'ยโสธร', 'หนองบัวลำภู',
  'สระบุรี', 'ระยอง', 'พัทลุง', 'ระนอง', 'อำนาจเจริญ', 'หนองคาย', 'ตราด',
  'พระนครศรีอยุธยา', 'สตูล', 'ชัยนาท', 'นครปฐม', 'นครนายก', 'ปัตตานี',
  'กรุงเทพมหานคร', 'ปทุมธานี', 'สมุทรปราการ', 'อ่างทอง', 'สมุทรสาคร',
  'สิงห์บุรี', 'นนทบุรี', 'ภูเก็ต', 'สมุทรสงคราม'].sort().map(
    item => ({value: item, label: item}));

export const DEFAULT_UI_SCHEMA = {
  excess: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'excess', props: {md: 6}},
      ], [
        {name: '50discount', props: {md: 6}},
      ], [
        {name: 'diff_payment', props: {md: 6}},
      ],
    ],
  },
  car: {
    'ui:field': LayoutField,
    'ui:layout': [
      // [
      //   {name: 'car_registration_no', props: {md: 6}},
      //   {name: 'province', props: {md: 6}},
      // ], 
      [
        {name: 'program_id', props: {md: 12}},
      ],
      [
        {name: 'car_type', props: {md: 6}},
        {name: 'brand_id', props: {md: 6}},
      ], [
        {name: 'model_id', props: {md: 12}},                
      ],[
        {name: 'mileage', props: {md: 3}},
        {name: 'mileage2', props: {md: 3}},
        {name: 'car_color', props: {md: 6}},
      ],
      // [
      //   {name: 'car_no', props: {md: 6}},
      //   {name: 'pr_fix_no', props: {md: 6}},
      // ],
      [
        {name: 'start_date', props: {md: 3}},
        {name: 'end_date', props: {md: 3}},
        {name: 'customer_name', props: {md: 6}},
      ]
    ],
    program_id: {'ui:field': 'SelectProgramList'},
    year: {'ui:field': 'SelectWithIcon'},
    province: {'ui:field': 'SelectWithIcon'},
    paint_type: {'ui:field': 'SelectWithIcon'},
    car_type: {'ui:field': 'SelectWithIcon','ui:multi':true},
    car_color: {'ui:field': 'SelectColor','ui:multi':true},
    brand_id: {'ui:field': 'SelectCarBrand','ui:multi':true},
    model_id: {'ui:field': 'SelectCarModel','ui:multi':true},
    series_id: {'ui:field': 'SelectCarSeries','ui:multi':true},
    start_date: {'ui:field': 'SelectDateTime'},
    end_date: {'ui:field': 'SelectDateTime'},
    customer_name: {'ui:field': 'SelectCustomer','ui:multi':true,'ui:select':false}
  },
  owner: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'title', props: {md: 1}},
        {name: 'name', props: {md: 3}},
        {name: 'customer_select', props: {md: 2}},
        {name: 'identity_no', props: {md: 6}},
      ], [
        {name: 'driver_license_no', props: {md: 6}},
        {name: 'tel', props: {md: 6}},
      ], [
        {name: 'address', props: {md: 6}},
        {name: 'other_tel', props: {md: 6}},
      ], [
        {name: 'province', props: {md: 6}},
      ], [
        {name: 'postalcode', props: {md: 6}},
      ],
    ],
    address: {'ui:widget': 'textarea'},
    title: {'ui:field': 'InputAutoComplete'},
    province: {'ui:field': 'SelectWithIcon'},
    customer_select: {'ui:field': 'SelectCustomer'},
  },
  driver: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'driver_as_owner', props: {md: 12},},
      ],
      [
        {name: 'title', props: {md: 1}},
        {name: 'name', props: {md: 3}},
        {name: 'customer_select', props: {md: 2}},
        {name: 'identity_no', props: {md: 6}},
      ],
      [
        {name: 'driver_license_no', props: {md: 6}},
        {name: 'tel', props: {md: 6}},
      ],
      [
        {name: 'address', props: {md: 6}},
        {name: 'other_tel', props: {md: 6}},
      ],
      [
        {name: 'province', props: {md: 6}},
      ],
      [
        {name: 'postalcode', props: {md: 6}},
      ],
    ],
    address: {'ui:widget': 'textarea'},
    title: {'ui:field': 'InputAutoComplete'},
    province: {'ui:field': 'SelectWithIcon'},
    customer_select: {'ui:field': 'SelectCustomer'},
  },
  insurer: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'insurer_id', props: {md: 6}},
        {name: 'province', props: {md: 6}},
      ],
      [
        {name: 'insurance_policy_no', props: {md: 6}},
        {name: 'insurance_type', props: {md: 6}},
      ],
      [
        {name: 'claim_no', props: {md: 6}},
        {name: 'cover_cost', props: {md: 6}},
      ],
      [
        {name: 'inform_no', props: {md: 6}},
        {name: 'inform_date', props: {md: 6}},
      ], [
        {name: 'accident_date', props: {md: 6, mdOffset: 6}},
      ],
    ],
    'insurance_type': {'ui:field': 'SelectWithIcon'},
    'province': {'ui:field': 'SelectWithIcon'},
    'inform_date': {'ui:field': 'SelectDateTime'},
    'accident_date': {'ui:field': 'SelectDateTime'},
  },
  receiving: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'contact_date', props: {md: 6}},
        {name: 'advance_date', props: {md: 6}},
      ], [
        {name: 'entrance_date', props: {md: 6}},
        {name: 'appointment_date', props: {md: 6}},
      ], [
        {name: 'entrance_name_as', props: {md: 6}},
        {name: 'fixing_day', props: {md: 6}},
      ], [
        {name: 'entrance_name', props: {md: 6}},
        {name: 'receiving_by', props: {md: 6}},
      ], [
        {name: 'tel', props: {md: 6}},
        {name: 'openwork_by', props: {md: 6}},
      ], [
        {name: 'other_tel', props: {md: 6}},
        {name: 'checking_by', props: {md: 6}},
      ], [
        {name: 'park_status', props: {md: 3}},
        {name: 'order_part', props: {md: 3}},
        {name: 'remark', props: {md: 6}},
      ],
    ],
    'park_status': {
      'ui:widget': 'radio',
      'ui:options': {
        inline: true,
      },
    },
    'order_part': {
      'ui:widget': 'radio',
      'ui:options': {
        inline: true,
      },
    },
    'entrance_name_as': {
      'ui:widget': 'radio',
      'ui:options': {
        inline: true,
      },
    },
    'openwork_by': {'ui:field': 'InputAutoComplete'},
    'checking_by': {'ui:field': 'InputAutoComplete'},
    'remark': {'ui:widget': 'textarea'},
    'advance_date': {'ui:field': 'SelectDateTime'},
    'appointment_date': {'ui:field': 'SelectDateTime'},
    'contact_date': {'ui:field': 'SelectDateTime'},
    'entrance_date': {'ui:field': 'SelectDateTime'},
  },
  delivering: {
    'ui:field': LayoutField,
    'ui:layout': [
      [
        {name: 'delivering_date', props: {md: 6}},
        {name: 'delivering_name_as', props: {md: 6}},
      ], [
        {name: 'relationship', props: {md: 6}},
        {name: 'delivering_name', props: {md: 6}},
      ], [
        {name: 'result', props: {md: 6}},
        {name: 'address', props: {md: 6}},
      ], [
        {name: 'asset', props: {md: 6}},
        {name: 'identity_no', props: {md: 6}},
      ], [
        {name: 'delivered_by', props: {md: 6}},
        {name: 'tel', props: {md: 6}},
      ], [
        {name: 'other_tel', props: {md: 6, mdOffset: 6}},
      ], [
        {name: 'tel_forsms', props: {md: 6, mdOffset: 6}},
      ],
    ],
    'delivering_name_as': {
      'ui:widget': 'radio',
      'ui:options': {
        inline: true,
      },
    },
    'delivered_by': {'ui:field': 'InputAutoComplete'},
    'address': {'ui:widget': 'textarea'},
    'relationship': {'ui:field': 'SelectWithIcon'},
    'delivering_date': {'ui:field': 'SelectDateTime'},
  },
};

export const DEFAULT_SCHEMA = {
  car: {
    title: '',
    type: 'object',
    required: [ 'program_id'],
    properties: {
      program_id: {
        type: 'array',
        title: 'โปรแกรม/แพ็กเกจ',
        default: '',
      },
      car_registration_no: {
        type: 'string',
        title: 'ทะเบียนรถ',
        default: '',
      },
      car_type: {
        type: 'string',
        title: 'ประเภทรถ',
        default: 'รถเก๋ง',
        options: {
          icon_base_url: 'https://demo2.bigfix.co/korat/img/',
          icon_size: '32x32',
          icon_ext: 'png',
          option_field: 'car_type_options',
        },
      },
      year: {
        type: 'string',
        title: 'ปี',
        default: new Date().getFullYear(),
        options: {
          option_field: 'model_year_options',
        },
      },
      car_color: {
        type: 'array',
        title: 'สีรถ'
      },
      chassis_no: {type: 'string', title: 'หมายเลขตัวถัง', default: ''},
      pr_fix_no: {
        type: 'string',
        title: 'เลขที่ใบสั่งซ่อม (ภายนอก)',
        default: '',
      },

      province: {
        type: 'string',
        title: 'จังหวัด',
        default: 'กรุงเทพมหานคร',
        options: {
          option_field: 'province_options',
        },
      },
      accident_type: {
        type: 'string',
        title: 'รถประกัน,รถคู่กรณี,เงินสด',
        default: 'รถประกัน',
        enum: ['รถประกัน', 'รถคู่กรณี', 'เงินสด'],
      },
      car_at: {
        type: 'string',
        title: 'คันที่',
        default: '1',
      },
      car_no: {
        type: 'string',
        title: 'เบอร์รถ (ถ้ามี)',
        default: '',
      },
      brand_id: {type: 'array', title: 'ยี่ห้อ'},
      model_id: {type: 'array', title: 'รุ่น'},
      series_id: {type: 'string', title: 'โฉมปี (แบบ)'},
      mileage: {type: 'string', title: 'หมายเลข กม.', default: ''},
      mileage2: {type: 'string', title: 'ถึง กม.', default: ''},
      engine_no: {type: 'string', title: 'หมายเลขเครื่อง', default: ''},
      damage: {
        type: 'string',
        title: 'สภาพรถ',
        default: 'กลาง',
        enum: ['ชนเบา', 'ชนกลาง', 'ชนหนัก'],
      },
      paint_type: {
        type: 'string',
        title: 'สีที่พ่น',
        default: 'สี 2K (สีแห้งช้า)',
        enum: ['มุก', 'สี 1K (สีแห้งเร็ว)', 'สี 2K (สีแห้งช้า)', 'โอปอ'],
      },
      start_date: {
        type: 'string',
        title: 'วันเริ่มต้น',
        default: '',
      },
      end_date: {
        type: 'string',
        title: 'วันสิ้นสุด',
        default: '',
      },
      customer_name: {
        type: 'array',
        title: 'ชื่อลูกค้า'
      }
    },
  },
  excess: {
    title: '',
    type: 'object',
    required: [''],
    properties: {
      'excess': {
        type: 'string', default: '',
        title: 'ค่าเสียหายส่วนแรก (Excess)',
      },
      '50discount': {
        type: 'string', default: '',
        title: 'ค่าส่วนต่าง 50% (ถ้ามี)',
      },
      'diff_payment': {
        type: 'string', default: '',
        title: 'ค่าส่วนต่างลูกค้าจ่ายเพิ่ม (ถ้ามี)',
      },
    },
  },
  owner: {
    type: 'object',
    properties: {
      title: {
        type: 'string',
        title: 'คำนำหน้า',
        default: '',
        options: {
          autocomplete_type: 'title',
          autocomplete_label: 'Name',
          autocomplete_value: 'Name',
        },
      },
      customer_select: {
        type: 'object',
        title: ' ',
      },
      name: {
        type: 'string',
        title: 'ชื่อผู้ครอบครอง',
        default: '',
      },
      driver_license_no: {
        type: 'string',
        title: 'เลขที่ใบขับขี่',
        default: '',
      },
      address: {
        type: 'string',
        title: 'ที่อยู่',
        default: '',
      },
      province: {
        type: 'string',
        title: 'จังหวัด',
        default: 'กรุงเทพมหานคร',
        options: {
          option_field: 'province_options',
        },
      },
      postalcode: {
        type: 'string',
        title: 'รหัสไปรษณีย์',
        default: '',
      },
      identity_no: {
        type: 'string',
        title: 'เลขบัตรประจำตัว',
        default: '',
      },
      tel: {
        type: 'string',
        title: 'หมายเลขโทรศัพท์',
        default: '',
      },
      other_tel: {
        type: 'string',
        title: 'เบอร์ติดต่ออื่น',
        default: '',
      },
    },
  },
  driver: {
    type: 'object',
    properties: {
      driver_as_owner: {
        type: 'boolean',
        title: 'ใช้ชื่อผู้ครอบครอง',
        default: false,
        disabled_fields: [
          'customer_select',
          'address',
          'driver_license_no',
          'identity_no',
          'name',
          'other_tel',
          'postalcode',
          'province',
          'tel',
          'title',
        ],
      },
      title: {
        type: 'string',
        title: 'คำนำหน้า',
        default: '',
        options: {
          autocomplete_type: 'title',
          autocomplete_label: 'Name',
          autocomplete_value: 'Name',
        },
      },
      customer_select: {
        type: 'object',
        title: ' ',
      },
      name: {
        type: 'string',
        title: 'ชื่อผู้ครอบครอง',
        default: '',
      },
      driver_license_no: {
        type: 'string',
        title: 'เลขที่ใบขับขี่',
        default: '',
      },
      address: {
        type: 'string',
        title: 'ที่อยู่',
        default: '',
      },
      province: {
        type: 'string',
        title: 'จังหวัด',
        default: 'กรุงเทพมหานคร',
        options: {
          option_field: 'province_options',
        },
      },
      postalcode: {
        type: 'string',
        title: 'รหัสไปรษณีย์',
        default: '',
      },
      identity_no: {
        type: 'string',
        title: 'เลขบัตรประจำตัว',
        default: '',
      },
      tel: {
        type: 'string',
        title: 'หมายเลขโทรศัพท์',
        default: '',
      },
      other_tel: {
        type: 'string',
        title: 'เบอร์ติดต่ออื่น',
        default: '',
      },
    },
  },
  receiving: {
    type: 'object',
    properties: {
      contact_date: {
        title: 'วันที่ติดต่อขอเข้าซ่อม',
        placeholder: 'วัน/เดือน/ปี',
        type: 'string', default: '',
      },
      entrance_date: {
        title: 'วันที่รับรถเข้าซ่อม',
        placeholder: 'วัน/เดือน/ปี',
        type: 'string', default: '',
      },
      entrance_time: {
        title: 'เวลา',
        placeholder: 'เวลา',
        type: 'string', default: '',
      },
      entrance_name_as: {
        title: 'ข้อมูลผู้ติดต่อ',
        type: 'string', default: '',
        enum: ['driver', 'owner', 'custom'],
        enumNames: ['ใช้ชื่อผู้ขับขี่', 'ใช้ชื่อผู้ครอบครอง', 'อื่นๆ'],
        disabled_fields: [
          'entrance_name',
          'tel',
          'other_tel',
        ],
      },
      entrance_name: {
        title: 'ชื่อผู้ติดต่อ',
        type: 'string', default: '',
      },
      tel: {
        title: 'หมายเลขโทรศัพท์',
        type: 'string', default: '',
      },
      other_tel: {
        title: 'เบอร์ติดต่ออื่น',
        type: 'string', default: '',
      },
      park_status: {
        title: 'รถจอดซ่อม?',
        type: 'string', default: '',
        enum: ['park', 'no_park'],
        enumNames: ['จอด', 'ไม่จอด'],
      },
      order_part: {
        title: 'สั่งอะไหล่?',
        type: 'string', default: '',
        enum: ['order', 'no_order'],
        enumNames: ['สั่ง', 'ไม่สั่ง (รอ)'],
      },
      advance_date: {
        title: 'วันที่นัดรับรถเข้าซ่อมล่วงหน้า',
        placeholder: 'วัน/เดือน/ปี',
        type: 'string', default: '',
      },
      appointment_date: {
        title: 'วันที่อู่นัดส่งมอบรถ (แสดงในปฏิทิน)',
        placeholder: 'วัน/เดือน/ปี',
        type: 'string', default: '',
      },
      fixing_day: {
        title: 'จำนวนวันที่คาดว่าจะเสร็จ',
        type: 'string', default: '',
      },
      receiving_by: {
        title: 'ชื่อเจ้าหน้าที่ผู้รับรถ',
        type: 'string', default: '',
      },
      openwork_by: {
        title: 'พนักงานอู่ที่เปิดเครื่อง',
        type: 'string', default: '',
        options: {
          autocomplete_type: 'carofficer',
          autocomplete_label: 'Name',
          autocomplete_value: 'Name',
        },
      },
      checking_by: {
        title: 'ผู้รับผิดชอบงาน',
        type: 'string', default: '',
        options: {
          autocomplete_type: 'carofficer',
          autocomplete_label: 'Name',
          autocomplete_value: 'Name',
        },
      },
      remark: {
        title: 'หมายเหตุ',
        type: 'string', default: '',
      },
      // emcs_no: {
      //   title: 'xxxx',
      //   type: 'string', default: '',
      // },
    },
  },
  delivering: {
    type: 'object',
    properties: {
      delivering_date: {
        title: 'วันที่ลูกค้ามารับรถ',
        type: 'string', default: '',
      },
      relationship: {
        title: 'เกี่ยวข้องกับผู้เอาประกัน',
        type: 'string', default: 'เจ้าของรถ',
        enum: ['เจ้าของรถ', 'ผู้ขับขี่', 'เพื่อน', 'คู่สมรส', 'ญาติ'],
      },
      result: {
        title: 'ผลการซ่อมรถ',
        type: 'string', default: '',
      },
      asset: {
        title: 'อุปกรณ์/ทรัพย์สินภายในรถ',
        type: 'string', default: '',
      },
      delivered_by: {
        title: 'ชื่อเจ้าหน้าที่ส่งมอบรถ',
        type: 'string', default: '',
        options: {
          autocomplete_type: 'carofficer',
          autocomplete_label: 'Name',
          autocomplete_value: 'Name',
        },
      },
      delivering_name_as: {
        title: 'ข้อมูลผู้รับรถ',
        type: 'string', default: 'custom',
        enum: ['driver', 'owner', 'custom'],
        enumNames: ['ใช้ชื่อผู้ขับขี่', 'ใช้ชื่อผู้ครอบครอง', 'อื่นๆ'],
        disabled_fields: [
          'identity_no',
          'delivering_name',
          'address',
          'tel',
          'other_tel',
        ],
      },
      delivering_name: {
        title: 'ชื่อผู้มารับรถ',
        type: 'string', default: '',
      },
      address: {
        title: 'ที่อยู่',
        type: 'string', default: '',
      },
      identity_no: {
        title: 'บัตรประจำตัวประชาชน',
        type: 'string', default: '',
      },
      tel: {
        title: 'เบอร์โทรศัพท์',
        type: 'string', default: '',
      },
      other_tel: {
        title: 'เบอร์ติดต่ออื่น',
        type: 'string', default: '',
      },
      tel_forsms: {
        title: 'เบอร์สำหรับส่ง SMS',
        type: 'string', default: '',
      },
    },
  },
  insurer: {
    type: 'object',
    properties: {
      insurer_id: {
        type: 'string', default: '',
        title: 'เลือกประกัน',
      },
      // insurer_name: {
      //   type: 'string', default: '',
      //   title: 'xxxxxxxx',
      // },
      insurance_policy_no: {
        type: 'string', default: '',
        title: 'หมายเลขกรมธรรม์',
      },
      claim_no: {
        type: 'string', default: '',
        title: 'เลขที่เคลม',
      },
      inform_no: {
        type: 'string', default: '',
        title: 'เลขที่แจ้งอุบัติเหตุ',
      },
      province: {
        type: 'string', default: '',
        title: 'สาขา',
        options: {
          option_field: 'province_options',
        },
      },
      insurance_type: {
        type: 'string', default: '',
        title: 'ประเภทกรมธรรม์',
        enum: [
          'ประกันภัยชั้น 1',
          'ประกันภัยชั้น 2',
          'ประกันภัยชั้น 2+',
          'ประกันภัยชั้น 3',
          'ประกันภัยชั้น 3+',
          'ประกันภัยชั้น 4',
          'พรบ'],
      },
      cover_cost: {
        type: 'string', default: '',
        title: 'จำนวนเงินคุ้มครอง',
      },
      inform_date: {
        type: 'string', default: '',
        title: 'วันที่แจ้งอุบัติเหตุ',
      },
      accident_date: {
        type: 'string', default: '',
        title: 'วันที่เกิดอุบัติเหตุ',
      },
    },
  },
};




// WEBPACK FOOTER //
// ./src/component/element/workdoc/FormUtils.js